import React, { useState, useEffect, useRef } from "react";
import Footer from "components/Footers/Footer";
import IndexNavbarr from "components/Navbars/IndexNavbarr";
import servicebg from "assets/img/servicebg.jpg";
import newbg from "assets/img/newbg.jpg";
import bgg2 from "assets/img/bgg2.png";
import { useForm } from "react-hook-form";
import emailjs from "@emailjs/browser";
import { Toaster, toast } from "react-hot-toast";

const Contactuae = () => {
    const [submitted, setSubmitted] = useState(false);
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm();

    const onSubmit = (data) => {
        emailjs
            .send("service_wcgta79", "template_ekccb7o", data, "fnc0ujCNZPYr2bPnl")
            .then(() => {
                toast.success("Form Submitted Successfully!");
                setSubmitted(true);
                reset();
            })
            .catch((error) => {
                console.error("EmailJS Error:", error);
                toast.error("Failed to submit form. Please try again.");
            });
    };

    return (
        <section>
            <IndexNavbarr />
            <section className="xl:pt-0 lg:pt-0 md:pt-24 pt-20">
                <div
                    className="relative xl:h-400 lg:h-300 md:h-240 h-200-px"
                    style={{
                        backgroundImage: `url(${bgg2})`,
                        width: "100%",
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        position: "relative",
                    }}
                >
                    {/* Black Overlay */}
                    <div
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            backgroundColor: "rgba(0, 0, 0, 0.6)",
                        }}
                    ></div>

                    <div style={{ position: "relative", zIndex: 1 }}>
                        <div className="xl:gap-0">
                            <div className="xl:pt-32 lg:pt-24 md:pt-20 pt-16">
                                <h1 className="xl:text-7xl lg:text-5xl md:text-4xl text-4xl text-center text-white uppercase font-bold fade-item-1">
                                    Contact
                                </h1>

                                <div>
                                    <div className="flex items-center justify-center bg-[#FDF5E6] rounded-lg xl:mt-6 lg:mt-4 mt-4">
                                        <div
                                            className="xl:w-2/12 lg:w-2/12 md:w-2/12 py-2 px-2 flex items-center gap-2 justify-center fade-item-2"
                                            style={{ border: "1px dashed white" }}
                                        >
                                            <span className="text-white xl:text-lg lg:text-lg font-semibold">
                                                <a href="/homepage1">Home</a>
                                            </span>
                                            <span className="text-white font-semibold"> »</span>
                                            <span className="text-white xl:text-lg lg:text-lg font-semibold">
                                                Contact
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className=" xl:pt-16 lg:pt-20 md:pt-16 pt-12 xl:px-0 px-4 ">
                <div className="container mx-auto ">
                    <div className="flex flex-wrap">
                        <div className="xl:w-5/12 lg:w-5/12">
                            <div className="px-2">
                                <div class="xl:w-6/12 flex items-center xl:gap-4 lg:gap-4 gap-4">
                                    <i
                                        class="fas fa-phone-alt text-blue scale-x-[-1] xl:text-2xl lg
                :text-2xl text-2xl"
                                    ></i>
                                    <div>
                                        <p class="xl:text-xl lg:text-xl text-lg font-semibold">
                                            Call Us
                                        </p>
                                        
                                        <p class="xl:text-base lg:text-base text-base font-semibold text-black">
                                            00971 50 633 0106
                                        </p>
                                    </div>
                                </div>
                                <div class="flex items-center xl:gap-4 lg:gap-4 gap-4 xl:mt-8 mt-4">
                                    <i class="fas fa-envelope-open-text text-blue xl:text-2xl lg:text-2xl text-2xl"></i>
                                    <div>
                                        <p class="xl:text-xl lg:text-xl text-lg font-semibold">
                                            Write email
                                        </p>
                                        <p class="xl:text-base lg:text-base text-base font-semibold text-black">
                                            info@innovativeprocesstechnologies.com
                                        </p>
                                    </div>
                                </div>
                                <div class="flex items-center xl:gap-4 lg:gap-4 gap-4 xl:mt-8 mt-4">
                                    <i class="fas fa-map-marker-alt text-blue xl:text-2xl lg:text-2xl text-2xl"></i>
                                    <div>
                                        <p class="xl:text-xl lg:text-xl text-lg font-semibold">
                                            Address
                                        </p>
                                        <p class="xl:text-base lg:text-base text-base font-semibold text-black">
                                            Business Center 1, M Floor, The Meydan Hotel, Nad Al Sheba, Dubai, UAE. 
                                        </p>
                                    </div>
                                </div>
                                <div className="xl:block lg:block md:hidden sm:hidden hidden xl:mt-8 mt-4">
                                    <div class="flex xl:gap-4 lg:gap-2 gap-4">
                                        <a
                                            href="#"
                                            class=" box bg-white h-10 w-10 flex items-center justify-center rounded-full text-black"
                                        >
                                            <i class="fab fa-facebook-f"></i>
                                        </a>
                                        <a
                                            href="#"
                                            class="box bg-white h-10 w-10 flex items-center justify-center rounded-full text-black"
                                        >
                                            <i class="fab fa-twitter"></i>
                                        </a>
                                        <a
                                            href="#"
                                            class="box bg-white h-10 w-10 flex items-center justify-center rounded-full text-black"
                                        >
                                            <i class="fab fa-youtube"></i>
                                        </a>
                                        <a
                                            href="#"
                                            class="box bg-white h-10 w-10 flex items-center justify-center rounded-full text-black"
                                        >
                                            <i class="fab fa-instagram-square"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="xl:w-7/12 lg:w-7/12 w-12/12 xl:pt-0 lg:pt-0 pt-12">
                            <div className="px-2">
                                <iframe
                                    className="xl:w-12/12 lg:w-12/12 md:w-12/12 w-full  rounded-md xl:h-360  lg:h-300 md:h-240 h-350-px"
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3608.1451150228854!2d55.38258969999999!3d25.265703400000003!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6ce4053c47e95e59%3A0x8124f455aaecad53!2sInnovative%20Process%20Technologies%20LLC%20Fz!5e0!3m2!1sen!2sin!4v1746525685755!5m2!1sen!2sin" width="600" height="450" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"
                                ></iframe>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <hr className="border-blue-50 xl:mt-16 lg:mt-12 md:mt-12 mt-12 container mx-auto"></hr> */}
            </section>

            <section className="headerbg1 xl:mt-16 lg:mt-16 md:mt-12 mt-12 xl:pt-16 xl:pb-20 lg:pt-16 lg:pb-20 md:pb-16 md:pt-8 pt-12 pb-12">
                <div className="container mx-auto xl:px-0 lg:px-0 md:px-0 px-4">
                    <div className="bg-white xl:w-6/12 lg:w-6/12 mx-auto xl:py-12 py-6 rounded">
                        <p className="xl:text-xl lg:text-xl text-xl font-bold text-blue  text-center uppercase">
                            Get In Touch
                        </p>

                        <div className="xl:block lg:block md:block sm:hidden hidden">
                            <h1 className="xl:text-4xl xl:pt-2 pt-2 lg:text-3xl md:text-3xl text-2xl font-bold text-black px-4 text-center">
                                Get In Touch And Contact Us !
                            </h1>
                        </div>

                        {/* mobile view */}
                        <div className="xl:hidden lg:hidden md:hidden sm:block block">
                            <h1 className=" pt-2 text-2xl font-bold text-black px-4 text-center">
                                Get In Touch And Contact Us
                            </h1>
                        </div>
                        <div className="xl:mt-12 lg:mt-12 px-4 md:mt-12 mt-12">
                            <Toaster position="top-center" reverseOrder={false} />
                            {/* {submitted && (
                <div className="text-green-600 font-semibold text-lg text-center">
                  ✅ Thank you! Your message has been sent successfully.
                </div>
              )} */}

                            <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
                                <div className="flex flex-wrap">
                                    <div className="xl:w-6/12 lg:w-6/12 w-full">
                                        <input
                                            type="text"
                                            {...register("fullname", {
                                                required: "Full Name is required",
                                            })}
                                            placeholder="Full Name"
                                            className="xl:w-12/12 lg:w-12/12 w-full rounded h-12 px-4 borderform"

                                        />
                                        {errors.fullname && (
                                            <p className="text-red-500">{errors.fullname.message}</p>
                                        )}
                                    </div>

                                    <div className="xl:w-6/12 lg:w-6/12 w-full xl:pl-2 lg:pl-2 md:pl-2 pl-0 xl:mt-0 lg:mt-0 md:mt-2 mt-2">
                                        <input
                                            type="email"
                                            {...register("email", {
                                                required: "Email is required",
                                                pattern: {
                                                    value: /\S+@\S+\.\S+/,
                                                    message: "Invalid email format",
                                                },
                                            })}
                                            placeholder="Email"
                                            className="xl:w-12/12 lg:w-12/12 w-full rounded-md h-12 px-4 borderform"

                                        />
                                        {errors.email && (
                                            <p className="text-red-500">{errors.email.message}</p>
                                        )}
                                    </div>
                                </div>
                                <div className="w-full py-2">
                                    <input
                                        type="number"
                                        {...register("tel", {
                                            required: "Phone Number is required",
                                        })}
                                        placeholder="Phone Number"
                                        className="w-full rounded h-12 px-4 borderform"

                                    />
                                    {errors.tel && (
                                        <p className="text-red-500">{errors.tel.message}</p>
                                    )}
                                </div>

                                {/* Products Dropdown */}
                                <select
                                    {...register("product", {
                                        required: "Please select a product",
                                    })}
                                    className="w-full rounded h-12 px-4 borderform"

                                >
                                    <option value="">Select a Product</option>
                                    <option value="Silos">Silos</option>
                                    <option value="Storage Tanks">Storage Tanks</option>
                                    <option value="Process Tanks">Process Tanks</option>
                                    <option value="Mixing Tanks">Mixing Tanks</option>
                                    <option value="CIP Tanks">CIP Tanks</option>
                                    <option value="Incubation Tanks">Incubation Tanks</option>
                                    <option value="Butter Melting Tanks">
                                        Butter Melting Tanks
                                    </option>
                                    <option value="Jacketed Tanks">Jacketed Tanks</option>
                                    <option value="Ribbon Blenders">Ribbon Blenders</option>
                                    <option value="Dry Mixing Tanks">Dry Mixing Tanks</option>
                                    <option value="Milk Road Tankers">Milk Road Tankers</option>
                                    <option value="Insulated Tanks">Insulated Tanks</option>
                                </select>
                                {errors.product && (
                                    <p className="text-red-500">{errors.product.message}</p>
                                )}

                                {/* Services Dropdown */}
                                <select
                                    {...register("services", {
                                        required: "Please select a service",
                                    })}
                                    className="w-full rounded h-12 px-4 mt-2 borderform"

                                >
                                    <option value="">Select a Service</option>
                                    <option value="Cheese Plants">Cheese Plants</option>
                                    <option value="Dairy Plants">Dairy Plants</option>
                                    <option value="Juice">Juice</option>
                                    <option value="Beverages">Beverages</option>
                                    <option value="Water Plants">Water Plants</option>
                                    <option value="Personal Care">Personal Care</option>
                                    <option value="Cosmetics">Cosmetics</option>
                                    <option value="Culinary">Culinary</option>
                                    <option value="Chocolate & Sweets">Chocolate & Sweets</option>
                                    <option value="Edible Oil">Edible Oil</option>
                                    <option value="Confectioneries">Confectioneries</option>
                                    <option value="Pharmaceuticals">Pharmaceuticals</option>
                                    <option value="Spices">Spices</option>
                                    <option value="Chemical">Chemical</option>
                                </select>
                                {errors.services && (
                                    <p className="text-red-500">{errors.services.message}</p>
                                )}

                                <textarea
                                    {...register("message", { required: "Message is required" })}
                                    placeholder="Write Your Message"
                                    className="w-full rounded h-32 px-4 py-2 mt-2 borderform"

                                />
                                {errors.message && (
                                    <p className="text-red-500">{errors.message.message}</p>
                                )}

                                <div className="flex gap-4">
                                    <button
                                        type="submit"
                                        className="blue xl:w-3/12 lg:w-3/12 w-3/12 text-white font-semibold xl:px-6 xl:py-2 lg:px-4 lg:py-2 px-2 py-2 mt-4 rounded-md shadow-md"
                                    >
                                        Submit
                                    </button>
                                    <a
                                        href="/brochure.pdf"
                                        download
                                        className="blue xl:w-4/12 lg:w-5/12 w-5/12 text-white font-semibold xl:px-6 xl:py-2 lg:px-4 lg:py-2 px-2 py-2 mt-4 rounded-md shadow-md"
                                    >
                                        Download Brochure
                                    </a>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
        </section>
    );
};

export default Contactuae;
